import { createContext } from "react";

export const SignupLink = createContext(null);
export const SetRegisterSuccess = createContext(null);
export const RegisterDependents = createContext(null);
